import { spacings } from "../../../assets/themes";
import { Block, List } from "../../../components";
import { LIST_HEADER } from "../../../components/Styles/variants";
import { formatDate } from "../../../utils";
import JobsItem from "./JobsItem";
import JobContent from "./item/JobContent";

const JobsWithMonthDividers = ({ data, children }) => {
  const renderJobsWithMonthDividers = (jobs) =>
    jobs.map((job, index) => {
      const currentMonth = formatDate(job.date, "YYYY-MM");
      const previousMonth =
        index > 0 ? formatDate(jobs[index - 1].date, "YYYY-MM") : null;
      const showMonthDivider = index === 0 || currentMonth !== previousMonth;

      return (
        <Block key={`job-wrapper-${job.id}`}>
          {showMonthDivider && (
            <Block marginTop={`calc(${spacings.xs} * -1)`}>
              <List.Header kind={LIST_HEADER.KIND.SUBTITLE}>
                <span style={{ textTransform: "capitalize" }}>
                  {formatDate(job.date, "MMMM")}
                </span>
              </List.Header>
            </Block>
          )}
          <JobsItem
            key={`job-${job.id}`}
            {...job}
            RightComponent={() => <JobContent {...job} />}
          >
            {children && children(job)}
          </JobsItem>
        </Block>
      );
    });

  return <Block spaceY={spacings.m}>{renderJobsWithMonthDividers(data)}</Block>;
};

export default JobsWithMonthDividers;
